import React from "react";
import { FormattedMessage } from "react-intl";
import { LoadingButton } from "@mui/lab";
import { Box, CircularProgress } from "@mui/material";
import { pulses } from "bundles/common/utils/utils";

const ShLoadingButton = ({
  type = "button",
  size,
  width,
  color,
  variant,
  pulsating,
  defaultLabelId,
  loading,
  loadingLabelId,
  showFinishedState,
  isSuccessful,
  successLabelId,
  isFailed,
  failLabelId,
  onClick,
}) => {
  const pulseClass = pulses();

  const staleLabel = () => {
    if (showFinishedState && isSuccessful) {
      return successLabelId ? <FormattedMessage id={successLabelId} /> : null;
    } else if (showFinishedState && isFailed) {
      return failLabelId ? <FormattedMessage id={failLabelId} /> : null;
    } else {
      return defaultLabelId ? <FormattedMessage id={defaultLabelId} /> : null;
    }
  };

  return (
    <LoadingButton
      type={type}
      size={size}
      style={{ minWidth: width }}
      className={pulsating ? pulseClass.pulse : ""}
      color={color}
      variant={variant}
      onClick={onClick}
      loading={loading}
      loadingIndicator={
        <Box style={{ display: "flex", alignItems: "center" }}>
          <Box style={{ minWidth: "24px", display: "flex" }}>
            <CircularProgress color="inherit" size={16} />
          </Box>
          {loadingLabelId ? (
          <Box style={{ whiteSpace: "nowrap" }}>
            <FormattedMessage id={loadingLabelId} />
          </Box>
          ) : null}
        </Box>
      }
    >
      {staleLabel()}
    </LoadingButton>
  );
};

export default ShLoadingButton;
